import styled from "styled-components";
import { TEXT_COLOR_ERROR } from "../../theme";

const ErrorMessage = styled.div`
  color: ${TEXT_COLOR_ERROR};
`;

export default ErrorMessage;
